import { useQuery } from '@tanstack/react-query';
import { getEntityByExternalId } from 'app/shared/api/entities';
import { ENTITY_QUERY_KEYS } from 'app/modules/entities/queries/keys';

export const useGetEntityByExternalId = (
  externalId: string,
  enabled = true,
) => {
  // DEPRECATED: This query is deprecated and should be removed once the cache entity details is working as expected
  return useQuery({
    queryKey: ENTITY_QUERY_KEYS.getEntityDetails(externalId, false, true),
    queryFn: () => getEntityByExternalId(externalId),
    meta: { errorMessage: 'Failed to retrieve entity.' },
    // TODO SC-60344 Manually fetching it until we get rid of the get entity by unit21 id
    enabled: Boolean(externalId) && enabled,
  });
};
